import { render } from "./CategoryFilter.vue?vue&type=template&id=330b1966&scoped=true"
import script from "./CategoryFilter.vue?vue&type=script&lang=js"
export * from "./CategoryFilter.vue?vue&type=script&lang=js"

import "./CategoryFilter.vue?vue&type=style&index=0&id=330b1966&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-330b1966"]])

export default __exports__